import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { clsx } from 'clsx';
function FormLabel(props) {
    const { text, className, isFieldRequired, ...labelAttrs } = props;
    const classes = clsx('form__label', className);
    if (!text) {
        return null;
    }
    return (_jsx("label", { ...labelAttrs, className: classes, children: _jsxs("span", { children: [text, isFieldRequired && _jsx("span", { className: "form__label-required", children: "*" })] }) }));
}
FormLabel.defaultProps = {
    isFieldRequired: false,
    text: undefined,
};
export default FormLabel;
